import { useState } from "react";
import { createUseStyles } from "$utils/createUseStyles";
import { SubmitHandler } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import Text from "$components/Text";
import ConnexionLayout from "./ConnexionLayout";
import ConnexionForm from "./ConnexionForm";
import authApi from "../../api/authApi";
import { publicIconPath } from "$utils/constants";

function Recovery() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [error, setError] = useState<string>("");

  const onSubmit: SubmitHandler<any> = async (data: any) => {
    await authApi
      .resetPassord(data.email)
      .then(() => {
        setError("");
        navigate("/succes");
      })
      .catch((reason: any) => {
        setError(reason.response.data);
      });
  };

  const onClickReview = () => {
    navigate("/connexion");
  };

  return (
    <ConnexionLayout onReview={onClickReview}>
      <img
        alt="ico-batail"
        src={`${publicIconPath}/logo.png`}
        className={classes.iconImg}
      />
      <Text type="h1" className={classes.connexionLabel}>
        Mot de passe oublié
      </Text>
      <Text className={classes.text}>
        Pas de panique, nous allons vous envoyer un mail
        <br />
        avec les instructions à suivre.
      </Text>
      <ConnexionForm
        onSubmit={onSubmit}
        connectionLabel="Envoyer"
        submitContainerClassName={classes.submitContainer}
        callbackError={error}
      />
    </ConnexionLayout>
  );
}

const useStyles = createUseStyles(() => ({
  connexionLabel: {
    marginBottom: 14,
  },
  text: {
    textAlign: "center",
    fontSize: 16,
    lineHeight: "22px",
  },
  submitContainer: {
    margin: [30, 0, 50, 0],
  },
  iconImg: {
    height: 100,
    marginLeft: 18,
  },
}));

export default Recovery;
